export const initialState = {
  logInfo: null,
  logTypesInTask: [],
  briefs: [],
  taskDetails: [],
  logDetail: null,

  highlightStartIndex: -1,
  highlightEndIndex: -1,
  focusLogId: -1,

  filterConditions: {
    keyword: "",
    logTypes: [],
  },
  sorted: true

};